import {FETCH_BAR_CATEGORY, FETCH_REPORT_BALANCE,FETCH_AVAIALABLE_COUPONS} from 'constants/ActionTypes'
const ROOT_URL = 'https://appvendedores.comprasdavivienda.cr/resources/ws/'

export function fetchBarCategory({dateFrom, dateTo}) {
  return dispatch => {
    fetch(
      `https://appvendedores.comprasdavivienda.cr/resources/ws/getCouponsByCategoriesReport.php/getCouponsByCategoriesReport?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    )
      .then(res => res.json())
      .then(res => dispatch({type: FETCH_BAR_CATEGORY, payload: res.result}))
      .catch(() => dispatch({type: FETCH_BAR_CATEGORY, payload: []}))
  }
}

export function fetchReportBalance({dateFrom, dateTo}) {
  return dispatch => {
    fetch(
      `https://appvendedores.comprasdavivienda.cr/resources/ws/getBalanceReport.php/getBalanceReport?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    )
      .then(res => res.json())
      .then(res => dispatch({type: FETCH_REPORT_BALANCE, payload: res.result}))
      .catch(() => dispatch({type: FETCH_REPORT_BALANCE, payload: []}))
  }
}

/*export function fetchAvailableCoupons({couponId}) {
  return dispatch => {
    fetch(
      `https://appvendedores.comprasdavivienda.cr/resources/ws/getAvailableCodesByCoupon.php/getAvailableCodesByCoupon?coupon=${couponId}`,
    )
      .then(res => res.json())
      .then(res => dispatch({type: FETCH_AVAIALABLE_COUPONS, payload: res.result}))
      .then ((data) => {this.setState({dataApi:data, success:data.success, result: data.result})
    })
      .catch(() => dispatch({type: FETCH_AVAIALABLE_COUPONS, payload: []}))
  }
}*/

export const fetchAvailableCoupons = couponId => dispatch =>{
  return fetch`https://appvendedores.comprasdavivienda.cr/resources/ws/getAvailableCodesByCoupon.php/getAvailableCodesByCoupon?coupon=${couponId}`
  .then(res => res.json())
  .then(json=>{
      dispatch({
          type:FETCH_AVAIALABLE_COUPONS,
          success:json.success,
          result: json.result
      });
  })
  .catch(error=>dispatch({type:FETCH_AVAIALABLE_COUPONS, message:error.message}));
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Reports.js